module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="selection-hook">\n    Currently selected '+
((__t=( total ))==null?'':_.escape(__t))+
' contacts\n    <br/>\n    <button class="button button-secondary view-all">\n        Edit\n    </button>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/contacts/selected.html
// module id = 260
// module chunks = 0